
import { Vue } from "vue-class-component";

export default class Eye extends Vue {}
